import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=7d822336&scoped=true&"
import script from "./Approval.vue?vue&type=script&lang=js&"
export * from "./Approval.vue?vue&type=script&lang=js&"
import style0 from "./Approval.vue?vue&type=style&index=0&id=7d822336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d822336",
  null
  
)

export default component.exports